import React, {useEffect} from "react";
import { motion } from "framer-motion";

const NotFound=()=>{
    useEffect(() => {
            document.title =
              "Page Not Found | Gurukrupa Wood Pvt. Ltd.";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "The page you are looking for could not be found. Explore Gurukrupa Wood Pvt. Ltd. products, services and packaging solutions."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://gurukrupawood.com/404");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Page Not Found | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "The page you are looking for could not be found. Explore Gurukrupa Wood Pvt. Ltd. products, services and packaging solutions."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://gurukrupawood.com/404");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://gurukrupawood.com/home.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Page Not Found | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "The page you are looking for could not be found. Explore Gurukrupa Wood Pvt. Ltd. products, services and packaging solutions."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://gurukrupawood.com/home.webp"
            );
          }
          }, []);
    return(
        <>

<section className="container not-found-section">

  {/* HEADING */}
  <motion.h1
    className="section-heading"
    initial={{
      opacity: 0,
      y: 60,
      scale: 0.9,
    }}
    animate={{
      opacity: 1,
      y: 0,
      scale: 1,
    }}
    transition={{
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    }}
  >
    <motion.span
      initial={{ opacity: 0, scale: 0.7 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        delay: 0.15,
        type: "spring",
        stiffness: 140,
      }}
      style={{ display: "inline-block" }}
    >
      404
    </motion.span>

    <br />

    <motion.span
      initial={{ opacity: 0, y: 25 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.35,
        duration: 0.7,
      }}
      style={{ display: "inline-block" }}
    >
      Page Not Found!
    </motion.span>
  </motion.h1>

  {/* TEXT */}
  <motion.p
    className="section-text"
    initial={{
      opacity: 0,
      y: 30,
    }}
    animate={{
      opacity: 1,
      y: 0,
    }}
    transition={{
      delay: 0.55,
      duration: 0.7,
    }}
  >
    The page you are looking for is not available or has been moved.
    Try a different page or go to homepage with the button below.
  </motion.p>

  {/* BUTTON */}
  <motion.a
    href="/"
    className="green-btn"
    initial={{
      opacity: 0,
      scale: 0.85,
    }}
    animate={{
      opacity: 1,
      scale: 1,
    }}
    transition={{
      delay: 0.75,
      duration: 0.5,
    }}
    whileHover={{
      scale: 1.05,
      y: -3,
    }}
    whileTap={{
      scale: 0.97,
    }}
  >
    Go To Homepage
  </motion.a>

</section>
        </>
    )
}
export default NotFound;